import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import NewUserModal from 'organisms/NewUserModal';
import DataTables from 'organisms/DataTable';
import { actionFormatter, imgFormatter } from 'molecules/TableFormatters';
import ModalPage from 'templates/ModalPage';
import { GET_USERS } from 'fixtures/api';
import { NewUser } from 'fixtures/TemplateData';
import { dashboardCreate, dashboardUpdate, dashboardDelete } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { postNewData, patchData, deleteData } from 'services/cmsService';
import { getLdapUserDetails } from 'services/authService';
import { getDeptsDataByCompany, resetDeptsData } from 'Redux/actions/DepartmentListActions';
import { getAllGroupsData } from 'Redux/actions/GroupMgmtActions';
import { getAllUsersData } from 'Redux/actions/UserMgmtActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { getAllCompaniesData } from 'Redux/actions/CompanyListActions';
import { getAllContractorsData } from 'Redux/actions/ContractorListActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageWrapper, TableWrapper } from './styles';
import lo from 'lodash';

import {
  TxtSuccessSubmitUser,
  TxtSuccessDeleteUser,
  TxtConfirmDeleteUser,
  TxtFailureGeneric,
  TxtFailedSubmitData,
  TxtFailedDeleteDept
} from 'fixtures/texts';

export class UserList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowModal: false,
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
      userData: {},
      navList: [
        'User',
        'User List'
      ],
      allowCreate: false,
      allowUpdate: false,
      allowDelete: false
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.resetDeptsData()
    this.props.getAllGroupsData()
    this.props.getAllUsersData()
    this.props.getAllCompaniesData()
    this.props.getAllContractorsData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { usersList, viewState: { isLoading }, userLogin } = this.props
    if (prevProps.usersList !== usersList && isLoading) {
      this.props.toggleIsLoading(false)
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, dashboardCreate),
        allowUpdate: permissionCheck(permissions, dashboardUpdate),
        allowDelete: permissionCheck(permissions, dashboardDelete),
      })
    }
  }

  // method for checking AD username
  async checkADUser(username) {
    this.props.toggleIsLoading(true)
    try {
      const ldapUserData = await getLdapUserDetails(username)
      if (ldapUserData) {
        Object.keys(ldapUserData).forEach((key, i) => {
          this.onChangeUserData(ldapUserData[key], key)
        })
      }
    } catch (error) {
      alert(TxtFailureGeneric)
    }
    this.props.toggleIsLoading(false)
  }

  // change user data state
  onChangeUserData(val, field) {
    let user = Object.assign(this.state.userData)
    user[field] = val

    if (field === 'photo') {
      let reader = new FileReader()
      reader.onloadend = () => {
        user.displayPictureBase64 = reader.result
        this.setState({ userData: user })
      }
      reader.readAsDataURL(val)
    } else if (field === 'originCompanyId'){
      this.props.resetDeptsData()
      user.departmentId = '-'
      this.props.getDeptsDataByCompany([val])
      this.setState({ userData: user })
    } else if (field === 'userRole' && val === 'CONTRACTOR'){
      user.contractorId = '-'
      this.setState({ userData: user })
    } else {
      this.setState({ userData: user })
    }
  }

  addNewUser() {
    this.switchModal(lo.cloneDeep(NewUser))
  }

  onSubmitUser() {
    const { userData: { photo, ...rest } } = this.state
    const transformed = lo.cloneDeep(rest)

    transformed.departmentId = transformed.departmentId === '-' ? null : transformed.departmentId
    transformed.contractorId = transformed.contractorId === '-' ? null : transformed.contractorId
    transformed.groups = transformed.groups.map(e => e.id)
    transformed.allowedCompanies = transformed.allowedCompanies.map(e => e.id)
    if (transformed.displayPictureBase64) {
      transformed.displayPictureBase64 = transformed.displayPictureBase64.split(',')[1]
    }

    const uri = transformed.hasOwnProperty('createdAt') ?
      `${GET_USERS}/${transformed.id}` :
      GET_USERS

    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        const res = transformed.hasOwnProperty('createdAt') ?
          await patchData(uri, transformed) :
          await postNewData(uri, transformed)

        if (res.status === 201 || res.status === 204) {
          alert(TxtSuccessSubmitUser)
          this.setState({ isSubmitDisabled: false })
          this.props.getAllUsersData()
          this.switchModal(NewUser)
        } else {
          throw res
        }
      } catch (err) {
        alert(TxtFailedSubmitData)
        this.setState({ isSubmitDisabled: false })
      }
    })
  }

  async onDeleteUser(user) {
    const isOk = window.confirm(TxtConfirmDeleteUser)
    if (isOk) {
      const uri = `${GET_USERS}/${user.id}`
      try {
        const res = await deleteData(uri)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteUser)
          this.props.getAllUsersData()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDeleteDept)
      }
    }
  }

  switchModal(userData, initSwitch = () => {}) {
    const { isShowModal } = this.state
    initSwitch()
    this.setState({ userData: userData }, () => {
      this.setState({ isShowModal: !isShowModal })
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const { isShowModal, isSubmitDisabled, isError, userData, navList } = this.state
    const { usersList, getDeptsDataByCompany, settingsTable, viewState: { isLoading, isMobileView } } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const config = [
      {
        dataField: 'displayName',
        text: 'Name',
        sort: true
      },
      {
        dataField: 'department.nameDisplay',
        text: 'Department',
        sort: true
      },
      {
        dataField: 'email',
        text: 'Email',
        sort: true
      },
      {
        dataField: 'username',
        text: 'Username',
        sort: true
      },
      {
        dataField: 'displayPictureUrl',
        text: 'Profile Picture',
        headerAttrs: { width: isMobileView ? 60 : 120 },
        formatter: imgFormatter,
        sort: false
      },
      {
        dataField: 'groups[0].name',
        text: 'Nama Group',
        sort: true
      },
      {
        dataField: 'userRole',
        text: 'Role',
        sort: true
      },
      {
        dataField: 'contractor.name',
        text: 'Contractor',
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 80 : 100 },
        formatter: actionFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          allowDel: this.state.allowDelete,
          edit: (row) => this.switchModal.bind(this, row, () => {
            getDeptsDataByCompany([row.originCompanyId])
          }),
          del: (row) => this.onDeleteUser.bind(this, row)
        },
        isDummyField: true
      }
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <NewUserModal
              fnChange={this.onChangeUserData.bind(this)}
              fnSubmit={this.onSubmitUser.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              fnGetUser={this.checkADUser.bind(this)}
              userData={userData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              {...this.props}
            />
          }
        />
        {!isLoading &&
          <TableWrapper>
            <DataTables
              minWidth={'700px'}
              leftSlot={
                this.state.allowCreate &&
                <ButtonReg
                  btnTxt={'Add'}
                  disabled={false}
                  onClick={() => this.addNewUser()}
                  width={'78px'}
                />
              }
              dataList={usersList}
              columnConfig={config}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
          </TableWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    companiesList: state.companiesList,
    groupList: state.groupList,
    deptsList: state.deptsList,
    contractorsList: state.contractorsList,
    usersList: state.usersList,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDeptsDataByCompany,
      resetDeptsData,
      getAllCompaniesData,
      getAllGroupsData,
      getAllContractorsData,
      getAllUsersData,
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserList);
